import type { DataOptions } from './types';
import sendXHR from './xhr';
import sendBeacon from './beacon';

export default async function sendData(
    { url, data, timeout, isDebug, isDrained, forceSendBeacon }: DataOptions & { isDebug?: boolean },
    callback?: (error?: any) => void
) {
    data = JSON.stringify(data);
    // 优先走 sendBeacon，如果成功把数据添加到 beacon 通道，则认为发送成功
    if (isDrained && sendBeacon({ url, data, forceSendBeacon })) {
        callback && callback();
        return;
    }
    const result = await sendXHR({ url, data, timeout }, callback);
    return result.error ? undefined : result.response;
}
